import { Stack } from '@mui/material';
import { ShikumLogo, MODLogo } from 'Images';
import { LogoButton } from './LogoButton';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

export const LogoButtons = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Header);

  return (
    <Stack
      width='fit-content'
      direction='row'
      alignItems='center'
      gap={isDesktop ? '40px' : '20px'}
    >
      <LogoButton
        text={dictionary.logoMobile}
        logo={ShikumLogo}
        href={`${process.env.REACT_APP_MARKETING_SITE_URL}`}
        ariaLabel={dictionary.logoMobile}
      />
      <LogoButton
        text={dictionary.ministryOfDefense}
        logo={MODLogo}
        href={`${process.env.REACT_APP_DEFAULT_MOD_BASE_URL}Pages/default.aspx`}
        ariaLabel={dictionary.ministryOfDefense}
      />
    </Stack>
  );
};
